var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SERVICE } from "@agentx/agentx-services";
import { action, makeObservable, observable } from "mobx";
import { logger } from "../logger/store-logger";
export class AgentStore {
    constructor() {
        this.agents = observable.map();
        this.subscriberIds = new Set();
        makeObservable(this);
    }
    subscribeToAgentStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                logger.info("[AgentStore] Subscribing to agent global status");
                const updateCallback = this.createUpdateCallback();
                const subscriberId = yield SERVICE.agentService.subscribeAgentGlobalStatusUpdates(updateCallback);
                this.subscriberIds.add(subscriberId);
                return subscriberId;
            }
            catch (error) {
                logger.error("[AgentStore] Error subscribing to agent global status", error);
                throw error;
            }
        });
    }
    stopAgentStatusUpdates(subscriberId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (subscriberId) {
                    yield SERVICE.agentService.stopAgentGlobalStatusUpdates(subscriberId);
                    this.subscriberIds.delete(subscriberId);
                }
            }
            catch (error) {
                logger.error("[AgentStore] Error stopping agent global status updates", error);
            }
        });
    }
    createUpdateCallback() {
        return (response) => {
            if (response.fullUpdate) {
                this.handleFullUpdate(response.fullUpdate);
            }
            else if (response.realTimeUpdate) {
                this.handleRealTimeUpdate(response.realTimeUpdate);
            }
        };
    }
    handleFullUpdate(fullUpdate) {
        this.agents = observable.map(fullUpdate.map((agent) => [agent.agentId, agent]));
    }
    handleRealTimeUpdate(realTimeUpdate) {
        const { updated, removed } = realTimeUpdate;
        if (updated) {
            updated.forEach((agent) => {
                this.agents.set(agent.agentId, agent);
            });
        }
        if (removed) {
            removed.forEach((agentId) => {
                this.agents.delete(agentId);
            });
        }
    }
}
__decorate([
    observable
], AgentStore.prototype, "agents", void 0);
__decorate([
    action
], AgentStore.prototype, "subscribeToAgentStatus", null);
__decorate([
    action
], AgentStore.prototype, "stopAgentStatusUpdates", null);
__decorate([
    action
], AgentStore.prototype, "handleFullUpdate", null);
__decorate([
    action
], AgentStore.prototype, "handleRealTimeUpdate", null);
